module.exports = __webpack_public_path__ + "media/img/event/Aurora-Scholarship-Campaign-e76e52f888a6704614f9800fdfdef357.jpg";